export default "data:text/javascript;base64,aW1wb3J0IE1hcE1haW4gZnJvbSAnLi9NYXBNYWluLnZ1ZScNCmV4cG9ydCB7IE1hcE1haW4gfQ0K"